import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useNavigationGuardStore = defineStore('navigationGuard', () => {
  const isBlocked = ref(false);

  const confirmModalLabels = ref<{
    title?: string;
    description?: string;
  }>({
    title: 'confirm_exit.title',
    description: 'confirm_exit.description',
  });

  const setConfirmModalLabels = (labels: {
    title?: string;
    description?: string;
  }) => {
    confirmModalLabels.value = {
      title: labels.title,
      description: labels.description,
    };
  };

  const setIsBlocked = (value: boolean) => {
    isBlocked.value = value;
  };

  const isExitConfirmed = ref(false);

  const setIsExitConfirmed = (value: boolean) => {
    isExitConfirmed.value = value;
  };

  return {
    isBlocked,
    setIsBlocked,
    isExitConfirmed,
    setIsExitConfirmed,
    confirmModalLabels,
    setConfirmModalLabels,
  };
});
